(function(angular, module) {var pagerController, pagerDirective;

pagerController = function($element) {
  'ngInject';
  this.tagList = $element.controller('dybTagpickerTagList');
  this.tagPicker = $element.controller('dybTagPicker');
  this.id = this.tagList.tagGroup.slug + "_" + this.direction;
  $element.addClass(this.direction);
  this.show = function() {
    var group;
    group = this.tagList.tagGroup;
    if (this.direction === 'next') {
      return group.hasNextPage;
    } else {
      return group.hasPreviousPage && group.allowPage;
    }
  };
  this.tagCount = function() {
    var group;
    group = this.tagList.tagGroup;
    if (this.direction === 'prev') {
      return group.offset;
    } else {
      return group.tags.length - group.offset - group.limit;
    }
  };
  this.click = function() {
    var group;
    group = this.tagList.tagGroup;
    if (this.direction === 'next' && !group.allowPage) {
      group.more();
    } else if (this.direction === 'next') {
      group.nextPage();
    } else {
      group.previousPage();
    }
  };
};

pagerDirective = function() {
  'ngInject';
  return {
    restrict: 'E',
    templateUrl: 'util/tags/pickerPager',
    scope: {
      direction: '@'
    },
    controller: pagerController,
    controllerAs: 'ctrl',
    bindToController: true,
    require: '^dybTagpickerTagList'
  };
};

module.directive('dybTagpickerPager', pagerDirective);
})(angular, angular.module("dybTags"));